import InternalStaticAnchorUserProfile from 'models/application/anchor/types/internalStatic/types/UserProfile';

export default class InternalStaticAnchorUserProfileService {
	toModel(anchor) {
		return new InternalStaticAnchorUserProfile(anchor);
	}
}
